import { render } from "./OrderCommentPopup.vue?vue&type=template&id=ba80e6da&scoped=true"
import script from "./OrderCommentPopup.vue?vue&type=script&lang=js"
export * from "./OrderCommentPopup.vue?vue&type=script&lang=js"

import "./OrderCommentPopup.vue?vue&type=style&index=0&id=ba80e6da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba80e6da"]])

export default __exports__